const project = {
	template: 'allianz', // caser or allianz
};

export default project;
